var wow = new WOW(
    {
        mobile:       true,       // trigger animations on mobile devices (default is true)
        live:         true,       // act on asynchronously loaded content (default is true)
    }
);
wow.init();
